import { combineReducers } from 'redux';
import { AuthActionTypes } from '../actions/AuthAction';
import AppReducer from './AppReducer';
import ArticleReducer from './ArticleReducer';
import AuthReducer from './AuthReducer';
import CharacterReducer from './CharacterReducer';
import NewsReducer from './NewsReducer';
import OcrReducer from './OcrReducer';

const CombiningReducer = combineReducers({
  appState: AppReducer,
  articleState: ArticleReducer,
  authState: AuthReducer,
  characterState: CharacterReducer,
  newsState: NewsReducer,
  ocrState: OcrReducer,
});

const RootReducer = (state, action) => {
  if (action.type === AuthActionTypes.AuthDone) {
    const { authState } = state;
    state = { authState };
  }

  return CombiningReducer(state, action);
};

export default RootReducer;
